function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Service from '@ember/service';
export default class SuperTextEditorManagerService extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "editors", []);
  }
  getEditor(indexOrName = 0) {
    const isString = typeof indexOrName === 'string';
    if (isString) return this.editors.findBy('name', indexOrName);
    return this.editors[indexOrName];
  }
  register(editor) {
    this.editors.push(editor);
  }
  deregister(editor) {
    const index = this.editors.indexOf(editor);
    this.editors.removeAt(index);
  }
}